export function generateBranding() {
    return /* html */ `
  <table class="wrapper" role="module" data-type="image" border="0" cellpadding="0"
    cellspacing="0" width="100%" style="table-layout: fixed;"
    data-muid="3e76f2c4-37a1-4b0d-8869-69838ce0e861">
    <tbody>
      <tr>
        <td style="font-size:6px; line-height:10px; padding:0px 0px 0px 0px;" valign="top"
          align="center">

          <a
            href="https://paidnice.com?utm_source=customer-email&utm_medium=referral&utm_campaign=pbl"><img
              class="max-width" border="0"
              style="display:block; color:#0000000; opacity:60%; text-decoration:none; font-family:Helvetica, arial, sans-serif; font-size:16px; max-width:15% !important; width:17%; height:auto !important;"
              width="140" alt="Powered by Paidnice" data-proportionally-constrained="true"
              data-responsive="true"
              src="https://storage.googleapis.com/logo-bucket-production/brandingemailimage.png"></a>
        </td>
      </tr>
    </tbody>
  </table>
  `;
}
//# sourceMappingURL=generateBranding.js.map